import { AppState } from "../../store";
//Selectors that pull values from state.
export const getAllDealers = (state: AppState) => state.reducer.Dealers.dealerList;
export const getActiveDealers = (state: AppState) => state.reducer.Dealers.dealerList.filter(x => x.locations!.filter(y => y.isActive === true));
export const getDealer = (state: AppState) => state.reducer.Dealers.dealer;
export const getAllDealerLocations = (state: AppState) => state.reducer.Dealers.dealerList.flatMap((x) => {return x.locations!});